import React, { useEffect } from 'react';

import { useUserContext } from '../../../contexts/UserContext';
import loginUser from '../../../api/services/Login';

const Login = () => {
  const user = useUserContext();

  useEffect(async () => {
    await user.signIn();
    await loginUser(user.token, user.user.userName);
  });

  return <div />;
};

export default Login;
